<template>
  <div class="util-latest-list">
    <div class="util-card" v-for="(row,i) in listdata" :key="i">
      <div class="util-card-date">
        <strong>{{ dayjs(row.date).format("D") }}</strong>
        <span>{{ dayjs(row.date).format("MMM") }}</span>
        <span>{{ dayjs(row.date).format("YYYY") }}</span>
      </div>
      <div class="util-card-detail ucdk">
        <div class="ucdk-item">
          <span>Duration</span>
          <p><strong>{{ row.downtime_minute }}</strong> min</p>
        </div>
        <div class="ucdk-item">
          <span>Mesin</span>
          <p><strong>{{ row.machine?.name }}</strong> TX322</p>
        </div>
        <div class="trcard">
          <span :class="`${row.status}`" style="text-transform: capitalize;">{{ row.status }}</span>
          <div @click="handleClick(row.id, row.status)"  style="width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;">
            <img src="@/assets/img/util-more.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Vue from "vue";
import dayjs from "dayjs";
import { Prop } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { nom  } from "@/api/api";
@Component({})
export default class UtilitiesListrikList extends Vue {
  @Prop () listdata;
  dayjs = dayjs
  nom = nom
  handleClick(id, status) {
    this.$emit("select", {id:id, status:status});
  }
}
</script>
